import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import Principal from './Principal';
import Restablecer from './Restablecer';
import VerificacionEmail from './VerificacionEmail';
import WhatsAppConnect from './pages/WhatsAppConnect';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TerminosServicio from './pages/TerminosServicio';
import EliminacionDatos from './pages/EliminacionDatos';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Principal />} />
        <Route path="/restablecer" element={<Restablecer />} />
        <Route path="/verificar" element={<VerificacionEmail />} />
        <Route path="/whatsapp-connect" element={<WhatsAppConnect />} />
        <Route path="/politica-privacidad" element={<PrivacyPolicy />} />
        <Route path="/terminos-servicio" element={<TerminosServicio />} />
        <Route path="/eliminacion-datos" element={<EliminacionDatos />} />
        {/* Ruta para admin (la crearás después) */}
        {/* <Route path="/admin/*" element={<AdminLayout />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;